import { Contract } from '@app/features/contracts/contract.model';
import { DAYS_OF_WEEK } from '@app/features/horaires/schedules.model';
import { AssignmentFormValue } from './embauche-tabs-form/assignment-form/assignment-form';
import { ContractFormValue } from './embauche-tabs-form/contract-form/contract-form';
import { DocumentsFormValue } from './embauche-tabs-form/documents-form/documents-form';
import { EmployeeFormValue } from './embauche-tabs-form/employee-form/employee-form';
import { SchedulesFormValue } from './embauche-tabs-form/schedules-form/schedules-form';

/** Les valeurs des onglets d'un contrat, et du récapitulatif qui les résume. */
export interface EmbaucheFormValues {
  contact: EmployeeFormValue;
  contract: ContractFormValue;
  schedules: SchedulesFormValue;
  assignment: AssignmentFormValue;
  documents: DocumentsFormValue;
}

/** Les valeurs des onglets d'un contrat ; celles d'un contrat vierge, sans contrat. */
export function embaucheFormValues(init?: Contract): EmbaucheFormValues {
  const contact: EmployeeFormValue = {
    id: init?.employee?.id || init?.employeeId || null,
    birthName: init?.employee?.birthName || null,
    firstname: init?.employee?.firstname || '',
    lastname: init?.employee?.lastname || '',
    email: init?.employee?.email || null,
    phoneNumber: init?.employee?.phoneNumber || null,
    title: init?.employee?.title || 'Monsieur',
    birthdate: init?.employee?.birthdate || null,
    birthplace: init?.employee?.birthplace || null,
    birthCountry: init?.employee?.birthCountry || null,
    socialSecurityNumber: init?.employee?.socialSecurityNumber || null,
    address: init?.employee?.address || null,
    postalCode: init?.employee?.postalCode || null,
    city: init?.employee?.city || null,
    nationality: init?.employee?.nationality || null,
    additionalAddress: init?.employee?.additionalAddress || null,
  };
  let contract: ContractFormValue = {
    id: null,
    previousContractId: null,
    companyId: '',
    contractType: 'CDI',
    startDate: '',
    endDate: null,
    endOfFirstTrialPeriodDate: null,
    jobId: null,
    qualificationLevel: null,
    grossHourlySalary: 0,
    replacement: null,
    companyCar: false,
  };
  if (init?.renewal) {
    contract = { ...contract, renewal: true };
  }
  if (init?.contract) {
    contract = {
      id: init.id ?? null,
      companyId: init?.company?.id || '',
      contractType: init.contract.contractType,
      startDate: init.contract.startDate,
      endDate: init.contract.endDate,
      endOfFirstTrialPeriodDate: init.contract.endOfFirstTrialPeriodDate,
      jobId: init.contract.jobType?.id || null,
      qualificationLevel: init.contract.qualificationLevel,
      grossHourlySalary: init.contract.grossHourlySalary,
      previousContractId: init.contract.previousContractId,
      replacement: null,
      companyCar: init.contract.companyCar || false,
    };
    if (init.contract.replacementReason || init.contract.replacementFirstName) {
      contract.replacement = {
        civility: init.contract.replacementCivility || 'Monsieur',
        reason: init.contract.replacementReason,
        firstName: init.contract.replacementFirstName,
        lastName: init.contract.replacementLastName,
        jobId: init.contract.replacementJobType?.id || null,
        qualificationLevel: init.contract.replacementQualificationLevel || null,
      };
    }
  }
  const schedules: SchedulesFormValue = init?.schedule
    ? {
        collectiveSchedules: init.schedule.collectiveSchedules || null,
        schedules: init.schedule.schedules || [],
      }
    : {
        collectiveSchedules: false,
        schedules: DAYS_OF_WEEK.map((day) => ({
          day: day,
          slots: [
            {
              startTime: '',
              endTime: '',
            },
          ],
        })),
      };
  const assignment: AssignmentFormValue = init?.assignmentType
    ? { assignmentType: init.assignmentType, residencies: init.residencies }
    : { assignmentType: 'TOURNEE', residencies: [] };
  const documents: DocumentsFormValue = init?.documents
    ? {
        documents: init.documents || [],
        metadata: {
          residentPermitExpirationDate:
            init.documentsMetadata?.residentPermitExpirationDate || null,
          drivingLicenseExpirationDate:
            init.documentsMetadata?.drivingLicenseExpirationDate || null,
        },
      }
    : {
        documents: [],
        metadata: {
          residentPermitExpirationDate: null,
          drivingLicenseExpirationDate: null,
        },
      };
  return { contact, contract, schedules, assignment, documents };
}
